import React from "react";
import { FaLocationArrow } from "react-icons/fa";

export default () => {
  return (
    <>
      <div className="studyinuk ">
        <h1 className="title">Universties</h1>
        <div className="unis container">
          <div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Algonquin College, Ottawa</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>
                Vancouver Institute of Professional Management, Vancouver, BC.
              </p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Columbia College,Vancouver ,BC</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Douglas College, BC</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Vancouver Island University, Vancouver,BC</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Lambton College, Sarnia, Toronto, Ontario</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Durham College ,Oshawa,Ontario</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Mohawk College ,Hamilton,Ontario</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Royal Roads University</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Farleigh Dickinson University</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Windsor University</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Sait Polytechnic College</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Grant McEwan University</p>
            </div>
          </div>
          <div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Alexander College,Vancouver, B.C</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Conestoga College, Kitchener,Ontario</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Confederation College,Thunder Bay, Ontario</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>North Island College,Vancouver,Bc</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Okanagan College,B.C</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Sheridan College ,Toronto,Ontario</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Camosun College,Victoria,BC</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Centennial College, Toronto</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Mc Master University (UG courses &MBA only)</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Thompson Rivers University</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Bow Valley College</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>New York Institute of Technology - Vancourver</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Dalhousie University</p>
            </div>
          </div>
          <div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Canadian College, Vancouver</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Niagara College, Ontario</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Seneca College ,Toronto ,Ontario</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>College of New Caledonia ,Prince george,BC</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>University of Manitoba(UG Courses only)</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>
                Saskatchewan Institute of Appled Science and Technology (SIAST)
              </p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Humber College, Toronto</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Fanshawe College,London,Ontario</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Carleton University</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>University of Waterloo(Dubai Campus UTP to Canada campus)</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>University of Concordia</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Laurentian University</p>
            </div>
            <div className="uni">
              <FaLocationArrow color="#16508e" />
              <p>Georgian College</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
